import { ChangeDetectionStrategy, Component, Injector, Input, ViewEncapsulation } from '@angular/core';
import { ILightWeightBusinessUnit } from '@fi-shared/models';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { isDefined } from '@fi-shared/utils';
import {
    FiDropdownItemAdditionalTextFn,
    FiDropdownItemDisabledFn,
    FiDropdownItemTitleFn,
} from '@fi-shared/fi-select-search/fi-select-search';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-form-viewer-business-unit-select',
    templateUrl: './fi-form-viewer-business-unit-select.component.html',
    styleUrls: ['./fi-form-viewer-business-unit-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-form-viewer-business-unit-select' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiFormViewerBusinessUnitSelectComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiFormViewerBusinessUnitSelectComponent,
        },
    ],
    standalone: false,
})
export class FiFormViewerBusinessUnitSelectComponent extends ControlValueAccessorValidatorBase<number> {
    @Input() availableBusinessUnits: ILightWeightBusinessUnit[] = [];
    @Input() disabled: boolean;

    constructor(
        private injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    onBusinessUnitIdChange() {
        this.ngModelChange.emit(this.ngModel);
    }

    isBusinessUnitDisabledFn: FiDropdownItemDisabledFn<ILightWeightBusinessUnit> = (
        item: ILightWeightBusinessUnit,
        allItems: ILightWeightBusinessUnit[],
    ) => {
        return !item.IsActivated;
    };

    getBusinessUnitTitleFn: FiDropdownItemTitleFn<ILightWeightBusinessUnit> = (
        item: ILightWeightBusinessUnit,
        allItems: ILightWeightBusinessUnit[],
    ) => {
        return !item.IsActivated ? this.appTextService.get('common.deactivated') : undefined;
    };

    getOptionAdditionalTextFn: FiDropdownItemAdditionalTextFn<ILightWeightBusinessUnit> = (
        item: ILightWeightBusinessUnit,
        allItems: ILightWeightBusinessUnit[],
    ): string => {
        if (!item.IsActivated) {
            return this.appTextService.get('common.deactivated');
        }
    };

    getOptionAdditionalClassFn: FiDropdownItemAdditionalTextFn<ILightWeightBusinessUnit> = (
        item: ILightWeightBusinessUnit,
        allItems: ILightWeightBusinessUnit[],
    ): string => {
        if (!item.IsActivated) {
            return 'red-color';
        }
    };

    doValidate(c: AbstractControl): ValidationErrors {
        return {
            required: !isDefined(this.ngModel),
        };
    }
}
